import { render, staticRenderFns } from "./TankManufacturersSpecs.vue?vue&type=template&id=2e433b16"
import script from "./TankManufacturersSpecs.vue?vue&type=script&lang=js"
export * from "./TankManufacturersSpecs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports